import React from "react";
import Logo from "../../assets/E.ON_Next_logo.svg";

/** Display an error */
const NotValidPage = (): JSX.Element => (
  <main className="main">
    <section className="logo-container">
      <img className="main-logo" alt="E.ON Next logo" src={Logo} />
    </section>
    <section className="text">
      <h5>Oops! This survey link has expired.</h5>
      <h1>This maybe because you&apos;ve used this link already,</h1>
      <h1>
        {" "}
        or the interaction for this survey happened more than two weeks ago.
      </h1>
    </section>
  </main>
);

export default NotValidPage;
